export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4823.199a2b48.jpg";